export default [
    {
        path: '/shop-info/index',
        name: 'shopInfo',
        meta: {
            index: 1
        },
        component: () => import('@/views/shop-info/index.vue')
    },
    {
        path: '/open-result',
        name: 'open-result',
        meta: {
            index: 2
        },
        component: () => import('@/views/shop-info/open-result.vue')
    }
]
